import _ from 'lodash';
import { colors, responsiveFontSizes } from '@material-ui/core';
import { THEMES } from 'src/constants';
import { softShadows, strongShadows } from './shadows';
import typography from './typography';
import { createTheme } from '@material-ui/core/styles';
import SITE_SETTINGS from 'src/constants/whiteLabel';
import { BRP_CLIENT } from 'src/constants/clients/brp';
import {
    blue,
    deepPurple,
    green,
    lightGreen,
    orange,
    pink,
    red,
    teal,
    yellow,
} from '@material-ui/core/colors';

const baseOptions = {
    direction: 'ltr',
    typography,
    overrides: {
        MuiLinearProgress: {
            root: {
                borderRadius: 3,
                overflow: 'hidden',
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: 32,
            },
        },
        MuiChip: {
            root: {
                backgroundColor: 'rgba(0,0,0,0.075)',
            },
        },
    },
};

const themesOptions = [
    {
        name: THEMES.CHRISTMAS_LIGHT,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: colors.common.white,
                dark: '#f4f6f8',
                paper: colors.common.white,
            },
            primary: {
                main: '#00873E',
            },
            secondary: {
                main: '#C30F16',
            },
            error: {
                main: '#f44336',
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.CHRISTMAS_DARK,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#282C34',
                dark: '#1c2025',
                paper: '#282C34',
            },
            primary: {
                main: '#00873E',
            },
            secondary: {
                main: '#C30F16',
            },
            error: {
                main: '#f44336',
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },

    {
        name: THEMES.BRP_LIGHT,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: colors.common.white,
                dark: '#f4f6f8',
                paper: colors.common.white,
            },
            primary: {
                main: '#FFD200',
            },
            secondary: {
                main: '#808080',
            },
            error: {
                main: '#f44336',
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.BRP_DARK,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#282C34',
                dark: '#1c2025',
                paper: '#282C34',
            },
            primary: {
                main: '#FFD200',
            },
            secondary: {
                main: '#808080',
            },
            error: {
                main: '#f44336',
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },

    {
        name: THEMES.LIGHT,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: colors.common.white,
                dark: '#f4f6f8',
                paper: colors.common.white,
            },
            primary: {
                main: '#423b77',
            },
            secondary: {
                main: '#423b77',
            },
            error: {
                main: '#f44336',
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.ONE_DARK,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#282C34',
                dark: '#1c2025',
                paper: '#282C34',
            },
            primary: {
                main: '#8a85ff',
            },
            secondary: {
                main: '#8a85ff',
            },
            error: {
                main: '#f44336',
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },

    {
        name: THEMES.DARK_RED,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#191919',
                dark: '#191919',
                paper: '#292929',
            },
            primary: {
                main: red[900],
            },
            secondary: {
                main: orange[200],
            },
            error: {
                main: red[700],
            },
            success: {
                main: green[700],
            },
            warning: {
                main: yellow[800],
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },
    {
        name: THEMES.LIGHT_RED,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: '#ffffff',
                dark: '#f0edf5',
                paper: '#f9f5ff',
            },
            primary: {
                main: red[900],
            },
            secondary: {
                main: orange[200],
            },
            error: {
                main: red[700],
            },
            success: {
                main: green[700],
            },
            warning: {
                main: yellow[800],
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },

    {
        name: THEMES.DARK_BLUE,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#191919',
                dark: '#191919',
                paper: '#292929',
            },
            primary: {
                main: blue[500],
            },
            secondary: {
                main: blue[800],
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },
    {
        name: THEMES.LIGHT_BLUE,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: '#ffffff',
                dark: '#f0edf5',
                paper: '#f9f5ff',
            },
            primary: {
                main: blue[500],
            },
            secondary: {
                main: blue[800],
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },

    {
        name: THEMES.LIGHT_PINK,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: '#ffffff',
                dark: '#f0edf5',
                paper: '#f9f5ff',
            },
            primary: {
                main: pink[100],
            },
            secondary: {
                main: pink[300],
            },
            error: {
                main: pink[600],
            },
            success: {
                main: teal[300],
            },
            warning: {
                main: orange[200],
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.DARK_PINK,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#2a2d3d',
                dark: '#222831',
                paper: '#2a323d',
            },
            primary: {
                main: pink[100],
            },
            secondary: {
                main: pink[300],
            },
            error: {
                main: pink[600],
            },
            success: {
                main: teal[300],
            },
            warning: {
                main: orange[200],
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },

    {
        name: THEMES.LIGHT_REGGAE,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: '#ffffff',
                dark: '#f0edf5',
                paper: '#f9f5ff',
            },
            primary: {
                main: lightGreen[900],
            },
            secondary: {
                main: red['A700'],
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.DARK_REGGAE,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#2a2d3d',
                dark: '#222831',
                paper: '#2a323d',
            },
            primary: {
                main: lightGreen[900],
            },
            secondary: {
                main: red['A700'],
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },

    {
        name: THEMES.LIGHT_LILA,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600],
                    },
                },
            },
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: '#ffffff',
                dark: '#f0edf5',
                paper: '#f9f5ff',
            },
            primary: {
                main: deepPurple[200],
            },
            secondary: {
                main: deepPurple[400],
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.DARK_LILA,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)',
            },
            background: {
                default: '#2a2d3d',
                dark: '#222831',
                paper: '#2a323d',
            },
            primary: {
                main: deepPurple[200],
            },
            secondary: {
                main: deepPurple[400],
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb',
            },
        },
        shadows: strongShadows,
    },
    {
        name: THEMES.CUSTOM_THEME,
    },
];

export const createWarboxTheme = (config = {}) => {
    let themeOptions = themesOptions.find(
        (theme) => theme.name === config.theme
    );

    if (!themeOptions) {
        console.warn(new Error(`The theme ${config.theme} is not valid`));
        const defaultThemeName =
            SITE_SETTINGS?.client === BRP_CLIENT
                ? THEMES.BRP_LIGHT
                : THEMES.LIGHT;
        themeOptions = themesOptions.find(
            (theme) => theme.name === defaultThemeName
        );
    }

    let theme = createTheme(
        _.merge({}, baseOptions, themeOptions, { direction: config.direction })
    );

    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }

    return theme;
};

export const createUserTheme = (config = {}) => {
    let theme = createTheme(
        _.merge({}, baseOptions, config, { direction: config.direction })
    );

    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }

    return theme;
};
